import React, { useState, useEffect } from 'react';
import Box from '@mui/joy/Box';
import ModalClose from '@mui/joy/ModalClose';
import Typography from '@mui/joy/Typography';
import Button from '@mui/joy/Button';
import Sheet from '@mui/joy/Sheet';
import Card from '@mui/joy/Card';

import { toast } from 'react-toastify';
import Modal from '@mui/joy/Modal';

import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import { useTextEditorDrawer } from '@/contexts/TextEditorDrawerContext';

dayjs.extend(utc);
dayjs.extend(timezone);

const PostScheduleModal = ({ setOpenDrawer, PostId, isScheduleModalOpen, setIsScheduleModalOpen, session, fetchPosts }) => {
    const userTimezone = session?.settings?.timezone;
    const [scheduledDateTime, setScheduledDateTime] = useState(dayjs().add(1, 'hour').tz(userTimezone));
    const { openManagePost, setOpenManagePost, toggleDrawer } = useTextEditorDrawer();

    const handleSchedule = async () => {
        try {
            setIsScheduleModalOpen(false);

            // Convert a UTC date to Madrid time
            const dateConvert = dayjs(scheduledDateTime).format('YYYY-MM-DD HH:mm:ss');
            const response = await fetch(`/api/schedule/create`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify({
                    post_id: PostId,
                    status: 'Scheduled',
                    scheduled_date: dateConvert,
                }),
            });

            const data = await response.json();
            if (response.status === 200) {
                setOpenManagePost(false);
                toast.success('This post has been scheduled!');
                fetchPosts();
            }

            else {
                const error_message = data.error || 'An error occurred while scheduling the post.';
                toast.error(error_message);
            }

            if (data.message) {
                setOpenManagePost(false);
            }
        } catch (error) {
            console.error("Error updating post:", error);
        }
    }

    return (
        <Modal open={isScheduleModalOpen} onClose={() => setIsScheduleModalOpen(false)} sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Sheet
                variant="outlined"
                sx={{
                    maxWidth: 500,
                    borderRadius: 'md',
                    p: 0,
                    boxShadow: 'lg',
                    backgroundColor: 'white',
                }}
            >
                <Box sx={{ padding: '1rem' }}>
                    <ModalClose variant="plain" sx={{ m: 1 }} />
                    <Typography level="h4" variant="plain">Schedule Post</Typography>

                    <Card sx={{ mt: 2 }}>
                        <Typography level="title-md" variant="plain">Select a date and time to schedule this post</Typography>
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                            <DateTimePicker
                                value={scheduledDateTime}
                                onChange={(newValue) => setScheduledDateTime(newValue)}
                                format='DD/MM/YYYY HH:mm'
                                minDateTime={dayjs().add(1, 'minute')} /*dayjs + 1 minute*/

                            />
                        </LocalizationProvider>
                    </Card>

                    <Box sx={{ display: 'flex', justifyContent: 'space-between', marginTop: '1rem', gap: 2 }}>
                        <Button size="lg" color="primary" onClick={handleSchedule}>Schedule Post</Button>
                        <Button size="lg" variant="outlined" color="danger" onClick={() => setIsScheduleModalOpen(false)}>Cancel</Button>
                    </Box>
                </Box>
            </Sheet>
        </Modal>
    );
};

export default PostScheduleModal;
